// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tab-chat[data-v-e4ce9078] {\n\theight: 100%;\n\n\t/* Remove padding to maximize the space for the chat view. */\n\tpadding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
